import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Marquee Sports Network',
    callsign: 'MARQ',
    logoUrl: networkLogos.marquee.logoUrl,
    slug: 'marquee-sports-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="MARQ"
        title="Watch Marquee Sports Network live with Fubo"
        networkName="Marquee Sports Network"
      />
    </>
  )
}
